import { useSuspenseQuery } from '@tanstack/react-query';
import { simProductsGraphsQueries } from '../queries/simProductsGraphsQueries';

import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { getActiveInSession } from '../api/simGraphsApi';

type UseActiveInSessionDataProps = {
  accountRef: string;
};

export const useActiveInSessionData = ({ accountRef }: UseActiveInSessionDataProps) => {
  return useSuspenseQuery<Awaited<ReturnType<typeof getActiveInSession>>>({
    queryKey: simProductsGraphsQueries.activeInSession({ accountRef }),
    queryFn: () => setMinimalPromiseTime(getActiveInSession({ accountRef })),
  });
};
